"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CANCELED = void 0;
exports.CANCELED = 'canceled';
